// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"ea0f70e8","467":"d8c616f8","819":"8194f92b"}[chunkId] + ".js";
};